import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = { class: "q-pa-md" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "q-pa-md" };
const _hoisted_6 = { class: "entry-check-table" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_checkbox = _resolveComponent("q-checkbox");
    const _component_q_field = _resolveComponent("q-field");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    ...(_ctx.isMultipleKeiyaku
                        ? [{ itemId: _ctx.PageID.taikyoRoomList }]
                        : []),
                    ...(_ctx.isNotification
                        ? [{ itemId: _ctx.PageID.taikyoNotificationFlowGuide }]
                        : [{ itemId: _ctx.PageID.taikyoFlowGuide }]),
                    { itemId: _ctx.PageID.taikyoPrecaution },
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", { innerHTML: _ctx.html }, null, 8, _hoisted_4)
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("table", _hoisted_6, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[2] || (_cache[2] = _createElementVNode("th", null, "個人情報の取り扱いについて", -1)),
                                                _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                                                    _createTextVNode(" ご提供頂いた個人情報は、お客様との連絡や書類の送付および解約に関する手続きを円滑に行うために、利用させて頂きます。 "),
                                                    _createElementVNode("br"),
                                                    _createElementVNode("a", {
                                                        href: "https://www.minitech.co.jp/company/privacy.html",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer"
                                                    }, "プライバシーポリシーについて"),
                                                    _createTextVNode("に同意します。 ")
                                                ], -1)),
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_q_field, {
                                                        outlined: "",
                                                        "bottom-slots": "",
                                                        error: _ctx.valid.privacyConsent.error,
                                                        "error-message": _ctx.valid.privacyConsent.message,
                                                        color: _ctx.privacyConsent ? 'green-7' : ''
                                                    }, {
                                                        control: _withCtx(() => [
                                                            _createVNode(_component_q_checkbox, {
                                                                modelValue: _ctx.privacyConsent,
                                                                "onUpdate:modelValue": [
                                                                    _cache[0] || (_cache[0] = ($event) => ((_ctx.privacyConsent) = $event)),
                                                                    _cache[1] || (_cache[1] = ($event) => (_ctx.isChangeOrSubmitted = true))
                                                                ],
                                                                label: "同意します"
                                                            }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["error", "error-message", "color"])
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    size: "lg",
                                    label: "同意して進む",
                                    color: _ctx.privacyConsent ? 'green-7' : 'green-4',
                                    "icon-right": "navigate_next",
                                    onClick: _ctx.saveConsentAndNavigate,
                                    disable: !_ctx.privacyConsent
                                }, null, 8, ["color", "onClick", "disable"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
